var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceCardDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 78,
    viewBox: "0 0 63 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.01834 16.8279L-10.5743 12.5481C-11.6044 11.3037 -11.3134 9.49022 -9.95153 8.58626C-2.23444 3.46383 7.03072 0.673828 16.4588 0.673828C25.887 0.673828 35.1521 3.46383 42.8634 8.58626C44.2252 9.49022 44.522 11.3037 43.4861 12.5481L39.9302 16.8279C39.0049 17.9383 37.3404 18.195 36.1182 17.3971C30.3217 13.5971 23.5765 11.5995 16.4588 11.5995C9.34119 11.5995 2.59601 13.5971 -3.20054 17.3971C-4.4227 18.2006 -6.08717 17.9383 -7.01252 16.8279H-7.01834Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4587 89.5576C7.79293 89.5576 -0.546881 87.2866 -7.84494 82.9676C-9.24752 82.1362 -9.63163 80.345 -8.67718 79.0561L-5.3657 74.5921C-4.50436 73.4314 -2.85153 73.0966 -1.57699 73.8332C3.85291 76.9803 10.0336 78.632 16.4587 78.632C22.8837 78.632 29.0644 76.9803 34.4885 73.8332C35.763 73.0966 37.4159 73.4259 38.2772 74.5921L41.5887 79.0561C42.5431 80.345 42.1648 82.1362 40.7564 82.9676C33.4584 87.2866 25.1186 89.5576 16.4528 89.5576H16.4587Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4235 71.0314L45.9597 67.6221C44.8016 66.7349 44.5339 65.139 45.3661 63.9672C49.3294 58.4095 51.4129 51.9423 51.4129 45.1179C51.4129 38.9632 49.6902 33.0317 46.4078 27.8255C45.6396 26.6035 45.983 25.0188 47.1993 24.193L51.8552 21.0179C53.1996 20.1028 55.0677 20.4711 55.9349 21.8159C60.4394 28.8132 62.8081 36.8093 62.8081 45.1179C62.8081 54.1575 59.8982 63.0409 54.5556 70.4344C53.6128 71.7401 51.7213 72.0247 50.4235 71.0314Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4593 67.3925C29.2904 67.3925 39.6921 57.4195 39.6921 45.1171C39.6921 32.8148 29.2904 22.8418 16.4593 22.8418C3.62822 22.8418 -6.77344 32.8148 -6.77344 45.1171C-6.77344 57.4195 3.62822 67.3925 16.4593 67.3925Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceCardDownIcon);
export default __webpack_public_path__ + "static/media/balance-card-down-icon.c59d20cf692e185c8febe0ae97e2432f.svg";
export { ForwardRef as ReactComponent };